<script>
	import {onDestroy} from "svelte";
	import './core/ecommerce.js';
	import {cartItemsStore, cartTotalStore, addToCart, decrementItemInCart, loadCart} from "./cart/cart-store.js";
	import {
		filterAllergens,
		filterFavorites,
		loadFavorites,
		toggleFavorite,
		favsStore,
		filtersStore,
		publishConfigStore, tenantKeyStore, menuStore
	} from "./core/app-store.js";
	import {
		closeAllergensFilterPanel,
		toggleAllergensFilterPanel,
		toggleSearchPanel,
		toggleSectionsPanel,
		toggleDetailsScreen,
		openCartScreen,
		closeCartScreen,
		openOrderItem,
		screensStore
	} from "./core/screens-manager.js";
	import {sanitizeText, scrollToElementId, scrollToTop} from "./core/utils.js";
	import Filters from "./components/Filters.svelte";
	import DetailsScreen from "./DetailsScreen.svelte";
	import Sections from "./components/Sections.svelte";
	import SocialLinks from "./components/SocialLinks.svelte";
	import CartWidget from "./cart/CartWidget.svelte";
	import CartScreen from "./cart/CartScreen.svelte";
	import {previewListener} from "./core/preview.js";
	import OrderItem from "./components/OrderItem.svelte";
	import TextBlock from "./components/TextBlock.svelte";
	import Header from "./components/Header.svelte";
	import OrderScreen from "./orders/OrderScreen.svelte";
	import OrderPlacementResultScreen from "./orders/OrderPlacementResultScreen.svelte";
	import SearchPanel from "./components/SearchPanel.svelte";
	import RecordListItem from "./components/RecordListItem.svelte";
	import GalleryLightbox from "./components/GalleryLightbox.svelte";
	import EditDetailsHalfScreen from "./details/EditDetailsHalfScreen.svelte";
	import Notification from './components/Notification/Notification.svelte';
	import WidgetYandexBusiness from "./components/WidgetYandexBusiness.svelte";
	import DocsBlock from "./components/DocsBlock.svelte";
	import ActionsPopup from "./components/Actions/ActionsPopup.svelte";
	import ActionNotification from "./components/Actions/ActionNotification.svelte";
	import LanguageSwitcher from './components/LanguageSwitcher.svelte';
	import {t} from "./core/i18n/language-store.js";
	import {platformStore} from "./components/PlatformLabel/platform-store.js";
	import PlatformLabel from "./components/PlatformLabel/PlatformLabel.svelte";

	loadCart();

	const publishConfig = M.publishConfig;
	let tenantKey;
	let favoritesList = [];
	let screens = {};
	let nothing_found;

	let menu = JSON.parse(JSON.stringify(M.menu));

	const uns1 = favsStore.subscribe(list => {

		favoritesList = list;

		menuStore.update(menu => {
			menu.sections.forEach(section => {
				(section.records || []).forEach(r => {
					r.isFavorite = favoritesList.includes(r.id);
				});
			});

			return {...menu};
		})
	});

	const applyFilter = (filters) => {

		menuStore.update(menu => {

			menu.sections.forEach(s => {
				(s.records || []).forEach(r => {
					const intersectedCount = (r.allergens || []).filter(a => filters.allergens.indexOf(a) > -1).length;
					const allergenFilter = intersectedCount !== 0;
					const favoritesFilter = filters.favorites === true && !favoritesList.includes(r.id);

					// clear old search result
					let searchTextFilter = false;
					r._found_desc = undefined;

					/// search by text
					if (filters.searchText && (r.name || r.description)) {

						/// search in name
						if (!r._name_lowcase) {
							r._name_lowcase = (r.name || '').toLowerCase();
						}

						searchTextFilter = r._name_lowcase.indexOf(filters.searchText) === -1;

						/// if not found, search in description
						if (searchTextFilter) {

							if (!r._description_lowcase) {
								r._description_lowcase = (r.description || '').toLowerCase();
							}

							if (r._description_lowcase.length > 0) {
								searchTextFilter = r._description_lowcase.indexOf(filters.searchText) === -1;
								if (!searchTextFilter) {
									r._found_desc = sanitizeText(r.description).replace(filters.searchText, `<em>${filters.searchText}</em>`);
								}
							}
						}
					}
					else if (!r.name || r.name.length === 0) {
						searchTextFilter = true;
					}

					r.isFilteredOut = allergenFilter || favoritesFilter || searchTextFilter;
				});

				s.isFilteredOut = (s.records || []).filter(r => !r.isFilteredOut).length === 0;
			});

			nothing_found = (menu.sections || []).filter(s => !s.isFilteredOut && s.sectionType !== 'text-block').length === 0;
			return {...menu};
		});
	}

	const unsM = menuStore.subscribe(x => {
		menu = x;

		if (screens.detailsRecord !== null && screens.detailsRecord !== undefined) {
			menu.sections.forEach(s => {
				(s.records || []).forEach(r => {
					if (r.id === screens.detailsRecord.id) {
						screensStore.update(s => {
							s.detailsRecord = r;
							return s;
						})
					}
				})
			})
		}
	});
	const unsS = screensStore.subscribe(s => screens = s);
	const unsF = filtersStore.subscribe(filters => applyFilter(filters));
	const unsT = tenantKeyStore.subscribe(key => tenantKey = key);

	const unsC = cartItemsStore.subscribe(cartItems => {

		menuStore.update(menu => {

			// TODO: Needs optimization
			menu.sections.forEach(s => {
				(s.records || []).forEach(r => {
					r._orderedItems = 0;
					r.prices.forEach((p, idx) => {
						p._count = undefined;
						cartItems.forEach(cartItem => {
							if (r.id === cartItem.id && idx === cartItem.priceIndex) {
								p._count = cartItem.count;
								r._orderedItems += cartItem.count;
							}
						});
					});
				});
			});

			return {...menu};
		});
	});

	loadFavorites(menu);

	onDestroy(() => {
		uns1();
		unsM();
		unsS();
		unsF();
		unsT();
		unsC();
	});

	const removeFromCartHandler = (record) => {
		if ((record.prices || []).length > 0) {
			const index = 0;
			const price = record.prices[index];
			decrementItemInCart(record, price, index);
		}
	}

	const addToCartHandler = (record, priceIdx) => {
		if ((record.prices || []).length > 0) {

			const priceIndex = priceIdx || 0;
			const price = record.prices[priceIndex];

			if ((price._count || 0) === 0) {
				addToCart(record, price, priceIndex);
			}
			else {
				openOrderItem({record, priceIndex});
			}
		}
	}

	const toggleFavoriteHandler = (record) => {
		record.isFavorite = !record.isFavorite;
		toggleFavorite({
			detail: {
				recordId: record.id,
				isFavorite: record.isFavorite
			}
		})
	}

	previewListener();
</script>

<style>

	main {
		flex: 1 1;
	}
	main .main {
		display: flex;
		flex-direction: column;
		flex: 1;
	}
	@media (min-width: 768px) {
		main {
			display: flex;
			justify-content: center;
		}
		main .main {
			max-width: 750px;
		}
	}
	@media (min-width: 1600px) {
		main .main {
			max-width: 1100px;
		}
	}

	.actions {
		padding: 0 1rem;
		display: flex;
		align-items: center;
		line-height: 1.5;
		gap: .75rem;
		background-color: var(--bg-color);
		font-size: .75rem;
		font-weight: 400;
		font-family: var(--font-2);
	}
	.actions .action {
		display: flex;
		align-items: center;
		gap: 0.25rem;
	}
	.actions .action:first-child {
		flex: 1 1;
		padding: 0.5rem 0;
	}
	.filter--applied {
		position: relative;
	}
	.filter--applied:after {
		position: absolute;
		content: '1';
		top: 0;
		right: -0.6rem;
		width: .6rem;
		height: .6rem;
		background: #d6b7a4;
		border-radius: 50%;
		font-size: 7px;
		text-align: center;
		color: white;
	}

	.sections {
		display: flex;
		flex-direction: column;
		gap: .8rem;
	}

	.section {}

	@media (min-width: 768px) {
		.sections {
			flex-direction: row;
			flex-wrap: wrap;
		}

		.section {
			flex: 1 1 45%;
		}
	}
	@media (min-width: 1600px) {
		.section {
			flex: 1 1 32%;
		}
	}

	.section-header {
		display: flex;
		gap: .25rem;
		padding: 16px 16px 0 16px;
		flex-direction: column;
		align-items: flex-start;
	}
	.section-header .section-title {
		color: var(--title-font-color);
		font-family: var(--font-1);
		font-size: 1.4rem;
		font-weight: 400;
		margin: 0;
		padding: 0;
		line-height: 20px; /* 100% */
		width: 100%;
		display: flex;
		align-items: baseline;
	}
	.section-header .section-title span {
		flex: 1 1;
	}
	.section-header .section-subtitle {
		color: var(--descr-font-color);
		font-family: var(--font-2);
		font-size: .9rem;
		font-style: normal;
		font-weight: 300;
		line-height: normal;
	}
	.section-header hr {
		margin: 0.5rem 0 1rem 0;
		border-top: none;
		border-left: none;
		border-right: none;
		border-bottom: 1px solid #E0DED9;
		width: 100%;
	}

	.section-records {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		padding: 0 1.25rem;
		margin: 0;
	}

	footer {
		padding: 1rem;
		text-align: center;
		background: var(--footer-bg-color);
		margin-top: 3rem;
	}
	footer .footer-restaurant-name {
		padding-top: .5rem;
		text-transform: uppercase;
		font-weight: 500;
		font-size: 1em;
		max-width: 100%;
		overflow-wrap: break-word;
	}
	footer p {
		font-size: .9rem;
	}

	.cart-space {
		height: 3.5rem;
	}

	.no-found-panel {
		padding: 1.5rem 1.25rem 2.75rem 1.25rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 400;
		color: var(--main-font-color);
		font-size: var(--fs-100);
	}
</style>


<CartWidget total={$cartTotalStore}
			showTotal={$publishConfigStore.userCanSeeTotal}
			publishConfig={$publishConfigStore}
			on:openCartScreen={openCartScreen}>
</CartWidget>


<DetailsScreen record={$screensStore.detailsRecord}
			   on:toggleFavorite={toggleFavorite}
			   on:close={toggleDetailsScreen}>
</DetailsScreen>

<EditDetailsHalfScreen></EditDetailsHalfScreen>

<CartScreen opened={$screensStore.cartOpened}
			showTotal={$publishConfigStore.userCanSeeTotal}
			on:close={closeCartScreen}>
</CartScreen>

<OrderScreen></OrderScreen>

<OrderItem></OrderItem>

<OrderPlacementResultScreen></OrderPlacementResultScreen>

<LanguageSwitcher />

<!-- MAIN CONTENT -->
<Header></Header>

<main>
	<div class="main" id="dm-menu">

		<div class="actions flex-between ai-center">
			<span class="action pointer" on:click={toggleSectionsPanel}>
				<span>{$t('nav.categories')}</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ChevronDown"><path d="M4 9l8 8 8-8"/></svg>
			</span>

			{#if (favoritesList.length > 0)}
			<span class="action pointer {$filtersStore.favorites ? 'filter--applied' : ''}" on:click={filterFavorites}>
				{$t('nav.favorite')}
			</span>
			{/if}

			{#if ($publishConfigStore.showAllergens)}
			<span class="action pointer {$filtersStore.allergens.length > 0 ? 'filter--applied' : ''}" on:click={toggleAllergensFilterPanel}>
				<span>{$t('nav.allergens')}</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ChevronDown"><path d="M4 9l8 8 8-8"/></svg>
			</span>
			{/if}

			<span class="search-button action action--icon pointer fs-110" on:click={toggleSearchPanel}>
				<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Search">
					<path d="M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"/>
				</svg>
			</span>
		</div>

		<!-- MENU SECTIONS FILTER -->
		<Sections opened={$screensStore.sectionsOpened}
				  sections={menu.sections}
				  on:scrollToSection={(e) => scrollToElementId('s' + e?.detail?.id)}>
		</Sections>

		<!-- ALLERGENS FILTERS -->
		<Filters opened={$screensStore.filtersOpened}
				 on:filter={filterAllergens}
				 on:close={closeAllergensFilterPanel}>
		</Filters>

		<SearchPanel></SearchPanel>

		{#if (nothing_found)}
			<div class="no-found-panel">{$t('nothingFound.search')}</div>
		{/if}

		<!-- MENU SECTIONS & ITEMS -->
		<div class="sections">
			{#each menu.sections as section, idx}
				{#if (section.isFilteredOut !== true || section.sectionType === 'text-block')}

					{#if (section.sectionType === 'text-block')}
						<TextBlock section="{section}" tenantKey="{tenantKey}"/>
					{:else }
						<div class="section">

							<!-- SECTION HEADER -->
							<div class="section-header">
								{#if (section.title) }
									<h3 id={'s' + section.id} class="section-title">
										<span>{section.title}</span>
										{#if (idx > 0) }
											<small on:click={() => scrollToTop()}>
												<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ArrowUp"><path d="M12 20V4"/><path d="M5 11l7-7 7 7"/></svg>
											</small>
										{/if}
									</h3>
								{/if}

								{#if (section.subTitle) }
									<div class="section-subtitle">{ section.subTitle }</div>
								{/if}

								<hr>
							</div>

							<section class="section-records">
								{#each (section.records || []) as record }
									{#if (record.isFilteredOut !== true)}
										<RecordListItem record={record}
														publishConfig={$publishConfigStore}
														tenantKey={tenantKey}
														on:removeFromCart={(e) => removeFromCartHandler(e?.detail)}
														on:addToCart={(e) => addToCartHandler(e?.detail.record, e?.detail.priceIdx)}
														on:toggleFavorite={(e) => toggleFavoriteHandler(e?.detail)}>
										</RecordListItem>
									{/if}
								{/each}
							</section>

						</div>
					{/if}

				{/if}
			{/each}
		</div>

	</div>
</main>

<footer class="layer-sections">

	<h2 class="footer-restaurant-name">{$publishConfigStore.restaurantName}</h2>

	<SocialLinks socialLinks={$publishConfigStore.socialLinks}></SocialLinks>

	{#if publishConfig.ybId}
		<WidgetYandexBusiness
				ybId={publishConfig.ybId}
				ybWidgetTheme={publishConfig.ybWidgetTheme}
		/>
	{/if}

	{#if $publishConfigStore.restaurantAddress}
	<p>
		{$publishConfigStore.restaurantAddress}

		{#if ($publishConfigStore.restaurantAddressLinkAction === 'yandex-maps' && $publishConfigStore.restaurantAddressLink)}
			(<a href="{$publishConfigStore.restaurantAddressLink}" target="_blank" rel="nofollow noopener">{$t('footer.map')}</a>)
		{:else if ($publishConfigStore.restaurantAddressLinkAction === 'geo' && $publishConfigStore.restaurantAddressGeo)}
			<span class="hide-on-desktop">(<a href="geo:{$publishConfigStore.restaurantAddressGeo}" target="_blank" rel="nofollow noopener">{$t('footer.map')}</a>)</span>
		{:else if ($publishConfigStore.restaurantAddressLinkAction !== 'none')}
			(<a href="https://maps.google.com/?q={$publishConfigStore.restaurantAddress}" target="_blank" rel="nofollow noopener">{$t('footer.map')}</a>)
		{/if}
	</p>
	{/if}

	<DocsBlock></DocsBlock>

	<PlatformLabel data={$platformStore}></PlatformLabel>

	{#if ($cartTotalStore?.count > 0)}
		<div class="cart-space"></div>
	{/if}
</footer>

<GalleryLightbox tenantKey={tenantKey}></GalleryLightbox>

<ActionsPopup></ActionsPopup>
<ActionNotification></ActionNotification>

<Notification />
